export const bestGoiReviews = [
  {
    id: 693,
    tags: ["상황", "장례지도사", "정책"],
    headline:
      "모두들 우리 지도사님의 연락처를 물어볼 정도로 누가 봐도 감동 받을 만한 그런 따뜻한 모습으로 잘 진행해 주셨던 것 같습니다.",
    good: "저희 가족들이 처음 맞이한 너무 나도 슬프고 황망한 상황에서 여러가지 절차들을 배려심 있게 잘 진행해 주셔서 진심으로 감사 드립니다. 상담 하면서 추가적으로 요청 드렸던   여러 가지 디테일 들을 진심 어리고 세심하게 반영해 주신 황경하 지도사 님께  꼭 감사 드린다는 말씀을 드리고 싶어요. 저희 가족에게는 너무 나도 소중한 마지막 시간 이었는데, 황경하 지도사님의 따뜻한 배려 덕분에 정말로 잘 마무리 할 수 있었던 것 같습니다. 장례식에 참석했던 제 친구들 지인들도 대부분 아직 이런 경험을 아직 다행히 못한 분들이 많았는데, 모두들 우리 지도사님의 연락처를 물어볼 정도로 누가 봐도 감동 받을 만한 그런 따뜻한 모습으로 잘 진행해 주셨던 것 같습니다. 그리고 , 처음에 상담을 친절하고 세심하게 진행해주셨던 엄윤선 팀장님께도 감사 하다는 말씀 꼭 드리고 싶네요. 다시 한번 두분께 감사 드립니다.",
    score: 5,
    created_at: "2025-01-29T10:55:22.035575+09:00",
    district: "경기도 성남시",
    user: {
      picture: "http://k.kakaocdn.net/dn/b6kJpS/btqyOQxBKnY/BOkgfQT1HNKGTmuLgD7Rx0/img_640x640.jpg",
      nickname: "고OO",
      age_and_gender: "50세 남성",
    },
  },
  {
    id: 689,
    tags: ["상황", "장례지도사", "정책"],
    headline:
      "어느 자리에서건 정말 흐트러짐 없으시고 대기할때조차도 타 지도사님들과 다르게 반듯하신 모습이 친척 어른들이 모두 정말 상조 잘 준비했다고 저에게 조용히 말씀하실 정도로요",
    good: "김유성 지도사님\n덕분에 오빠를 편안히 보내주고 이렇게 후기도 씁니다.\n\n젊은 나이 빠르게 진행된 암으로 오빠의 고통스러운 나날을 주 보호자로서 지켜보던 엄마는 얼마나 더 가슴이 미어질지.. 이런저런 걱정으로 일련의 과정들이 모두 조심스러웠어요\n죽음앞에 슬프지 않은 사연 없다지만\n애써 키워낸 자식을 보내는 엄마아빠의 마음은\n감히 상상할 수 없을거라 생각해요\n\n상조를 미리 알아보는게 오빠의 긴 여행을 독촉하는건 아닐까 망설였지만\n막상 일이 닥쳤을때 허둥지둥 하기보다는\n오빠가 여행가는 먼 길 헤매지 않도록 경황없을 부모님대신 제가 알아보고 가입했어요\n\n위독하다는 연락 받고 상조대표번호로 연락하니 따뜻하게 위로해주시고 문의사항 꼼꼼히 정리해서 연락주신 팀장님 먼저 감사드립니다. \n\n임종후 연계받은 우리 김유성 지도사님\n인천부터 분당까지 달려와주셔서\n이런저런 절차들을 왜 이렇게 해야하는지도 꼼꼼히 알려주시고 납득시켜주셨어요\n\n상조라는게 사실 필요할까 싶었는데\n하다보니 꼭 있어야 하는구나..\n잘 준비했다 싶었던 순간들이 정말 많습니다.\n\n입관식전 엄마의 의견 하나하나 경청해주시고\n원하는바를 정확히 캐치해주셨어요.\n\n10개월 투병중 8개월을 병원에서 하지마비로 답답했을 오빠를 위해 매듭과 얼굴만큼은 감싸지않았으면 한다는 부탁들, 종교는 불교이지만 요청드린 사항들에대해\n이렇게 하면 어떨까요, 저렇게 하면 될것같습니다\n\n뭐하나 막힘없이 그렇다고 예에 크게 어긋남 없이\n정말 꼼꼼하고 정갈하게 정성스럽게 해주셨어요\n\n이런것은 왜 해야하는지 상주의 역할등\n설명도 잘 해주시고 뭐하나 의아한 부분없이\n진짜 꼼꼼하십니다.\n\n\n오빠에게 마지막 인사를 마치고서\n 엄마가 저에게 하시는 말씀이\n이런 지도사님을 어떻게 만났냐고,\n 너무 잘 하신다며 감사하고 좋은분이라고\n엄마가 아주 나중에 혹시나 떠날때\n김유성지도사님 그때까지 계신다면 꼭 꼭 맡겨달라고 당부하셨어요..\n\n친척동생이 일정 모두 마치고 인사하는 와중에\n명함을 요청해서\n큰아버지 큰어머니가 당황해 하셨네요 , ㅎ\n\n어느 자리에서건 정말 흐트러짐 없으시고\n대기할때조차도 타 지도사님들과 다르게 반듯하신 모습이 친척 어른들이 모두 정말 상조 잘 준비했다고\n저에게 조용히 말씀하실 정도로요\n\n\n오빠 보내는 길, 아픈마음은 어쩔수 없지만\n오빠의 긴 여행을 안내해준 김유성지도사님께\n엄마가 너무너무 만족스러워 하셔서 그게 가장 감사했습니다.\n\n힘든 일을 치루며 고이 상조에서\n김유성 장례지도사님 만나게 되어 \n정말 많은 마음의 위안이 되었습니다.\n\n이 자리를 빌어 다시한번 감사인사 드립니다.\n\n상주 김초롱 드림",
    score: 5,
    created_at: "2025-01-27T14:46:35.079022+09:00",
    district: "경기도 성남시",
    user: {
      picture: "http://k.kakaocdn.net/dn/jBRxE/btsKL6nzCy6/dTB3KKstx2ur9ekKrp5kwK/img_640x640.jpg",
      nickname: "김OO",
      age_and_gender: "39세 여성",
    },
  },
  {
    id: 682,
    tags: ["상황", "상담", "장례지도사", "정책"],
    headline:
      "고이상조는 3번째로 문의를 한 상조회사였습니다. 앞서 문의했던 상조들은 자신들의 상조의 저렴성을 강조하고 불친절했던 반면, 고이상조는 굉장히 친절했습니다.",
    good: "저희 가족은 아버지의 갑작스러운 소천 비보를 듣고 모두 당황한 상태였습니다. 어머니께서 가족장으로 조용히 지냈으면 좋겠다고 하셔서 무빈소를 알아보았습니다. 무빈소의 가격이 생각보다 저렴한 곳도 많아서 이 가격에 가능할까 하는 생각도 들었습니다. 역시 상담을 받아보니 장례식장 사용료(입관비, 안치료, 빈소 등)가 빠진 업체가 많았고, 관이나 수의, 유골함의 가격 등을 통해 책정가격이 상당히 올라가더라고요. 아무래도 부모님 가시는 길에 좋은 것을 해 드리고 싶은 가족들의 마음 때문에 가격비용이 많이 올라갔습니다.\n\n일단, 저희가 중점적으로 본 사항은\n1. 친절성 \n2. 신뢰성\n3. 가격의 합리성\n4. 고인께 해드리는 특별한 마음(꽃관, 리무진, 좋은 유골함) \n\n여러 군데 상조를 전화해본 결과, 저렴한 곳일수록 친절하지 않고, 그러다 보니 신뢰성이 많이 떨어지더라구요. 그리고 무빈소의 경우, 병원에 있는 업체를 이용하는 경우도 많은데 추천드리고 싶지 않습니다. 일단 병원 장례식장 업체는 관이 너무 간소화되어 마음에 걸렸습니다. 가격도 상조회사와 비슷한데 관 장식이 관보와 입관용 고깔이 전부였습니다. 그래도 고인 가시는 길이 꽃길이길 바라는 마음에 꽃관으로 해드리고 싶었는데, 그런 게 전혀 없었습니다. 그래서 병원보다는 상조회사를 추천해 드립니다.\n\n“정말 만족스러운 <고이상조>”\n1. 친절한 상담\n고이상조는 3번째로 문의를 한 상조회사였습니다. 앞서 문의했던 상조들은 자신들의 상조의 저렴성을 강조하고 불친절했던 반면, 고이상조는 굉장히 친절했습니다.\n일단, 화장터의 시간부터 알아봐주고, 자리가 없다는 것을 미리 알려주셨습니다. 그리고 자신들과 계약을 하든 안하든 일단 화장터 예약부터 넣어드리겠다며 성심성의껏 어려움을 해결해주셨습니다. 나중에 알게 되었는데 상담사분이 본부장님이셨는데, 너무 친절하셔서 정말 불안한 마음이 많이 안정되었습니다. 정말 감사하다는 말을 몇 번이고 하게 만드는 친절함이었습니다. \n\n2. 신정훈 장례지도사님의 대면상담\n무빈소로 진행하다보니 일단 입관일까지 상담을 받을 시간이 좀 남았습니다. 저희 가족이 장래가 처음이다보니 너무 몰랐는데, 신정훈 장례지도사님이 미리 오셔서 대면상담을 해 주셨습니다. 한 시간이 넘게 상담해주셨고, 장례절차뿐 아니라 과정, 무빈소에 대한 기본적 이해를 친절히 설명해주셨습니다. 그리고 다른 상조회사와는 달리 비싼 패키지를 권하는 것이 아니라 정찰제 패키지로 권하며 진행해주셨고, 필요한 부분 역시 빠짐없이 세심히 챙겨 주셔서 너무 신뢰감이 생겼습니다. 신정훈 장례지도사님의 친절하고 신뢰감 있는 태도와 선한 인상에 입관일에 꼭 신정훈 장례지도사님이 와주시기를 부탁드렸습니다.  \n\n3. 입관일\n꽃관을 너무 예쁘게 만들어주시고, 면도와 머리까지 잘 다듬고 얼굴도 잘 분칠해주셔서 아버지를 편안히 뵐 수 있었습니다. 특히 신정훈 장례지도사님의 침착하고 안정감주는 안내를 통해 아버지를 잘 보내드릴 수 있었습니다. \n\n4. 리무진\n무빈소 장례이다보니, 가족들이 화장터까지 자차로 이동하고 리무진을 이용해 아버지를 모셨습니다. 리무진은 더 특별하게 고인을 모시는 거란 신정훈 장례지도사님의 말처럼 아버지에게 좀 더 편안히 길을 안내해드린 것 같아 좋았습니다. 리무진 기사님께서는 승차와 하차시 모든 분께 허리 숙여 인사를 건내 주셨고, 한 분 한 분 정성껏 모시는 느낌이 들어 더 감사했습니다. \n\n5. 추모원(봉안시설)\n추모원에 모시기로 했는데, 신정훈 장례지도사님께서 봉안시설의 가장 좋은 자리를 안내해주셨습니다. 남향의 창이 큰 자리, 그리고 인사 나누기 좋은 높이의 자리를 세심히 한 곳 한 곳 안내해 주셔서 아버지를 정말 좋은 자리에 모실 수 있었습니다. 좋은 자리는 다른 사람이 먼저 선택할 수 있기에 신정훈 장례지도사님이 번호표도 아주 빨리 뽑아서 다른 가족분들보다 먼저 봉안시설의 좋은 자리를 선택할 수 있었습니다. \n\n리뷰를 마치며\n원래 리뷰를 이렇게 길게 쓰지 않는데, 너무 ‘정성껏 도움을 받았다’라는 표현이 적합할 정도로 너무 감사한 마음만 남았습니다. 갑작스럽고 당황스러운 상황에 아버지를 너무 편히 모실 수 있었고, 귀한 대접으로 보내드릴 수 있어 감사했습니다. 너무 친절하게 상담해주셔서 고이상조로 선택할 수 있게 도움을 주신 본부장님, 그리고 마음을 다해 주신 최고의 장례지도사님인 신정훈 장례지도사님께 감사함을 전합니다. 저희 가족들 모두 너무 만족스러운 ‘고이상조’ 무빈소 장례였습니다. 그리고 꼭 신정훈 장례지도사님을 추천드리고 싶습니다.",
    score: 5,
    created_at: "2025-01-22T14:29:46.790593+09:00",
    district: "경기도 성남시",
    user: {
      picture: "http://k.kakaocdn.net/dn/L1sFG/btsKeVTOjn5/qPbke6nwBsX94mGteK4TV0/img_640x640.jpg",
      nickname: "박OO",
      age_and_gender: "",
    },
  },
  {
    id: 558,
    tags: ["장례지도사", "정책"],
    headline:
      "최상의 서비스에 매우 고마움을 느끼며, 상조의 선입견을 잊게 해 주셨습니다. 별 다섯개도 모자랄 만큼의 배려와 위안을 받게 해 주신 ‘문현선’팀장님께 마음으로 표현 할 수 없을 정",
    good: "발인을 마치 면서..그 동안 진심으로 가족처럼 장례 절차를 진행 해 주신 ‘문현선’팀장님께 고마움을 전합니다.\n\n2024/10/19/토요일 밤에 작고 하신 엄마를 모셔 놓고, ‘문현선’팀장님을 처음 뵈었는데 신뢰 가는 톤의 목소리로 자세한 일정과 설명이 안정적인 마음을 갖게 했습니다.\n\n20일- 아침 일찍 오셔서 고인의 예와 장례 예절을 알려 주셔서 실수 안하고, 상식도 알게 되는 계기가 되었습니다.그리고 오랜 세월 병환으로 영면에 드시는 저희엄마를 성심 성의껏 대해 주셨고, 자연스러운 화장으로 안색을 살려 어여쁘게 꾸며주시고, 생화로 아름답게 꾸며 줘서 입관식도 부족함 없이 저의 마음을 충분하게 전할 수 있는 시간이 되었습니다.\n\n21일- 찾아 오신 손님들 돌아가 실 때 음식도 챙겨 주시고, 혼자 지내는 오빠의 반찬도 챙겨 주신 마음씀씀이에 한 번 더 감사드립니다.\n장지에서도 서류 정리와 엄마의 마지막 서류 작업에 대해서도 꼼꼼하게 챙겨 주셨습니다.\n최상의 서비스에 매우 고마움을 느끼며, 상조의 선입견을 잊게 해 주셨습니다.\n별 다섯개도 모자랄 만큼의 배려와 위안을 받게 해 주신 ‘문현선’팀장님께 마음으로 표현 할 수 없을 정도의 상조 서비스를 받게 되어 영광으로 생각하겠습니다.",
    score: 5,
    created_at: "2024-10-22T15:45:41.131555+09:00",
    district: "-",
    user: {
      picture: "http://k.kakaocdn.net/dn/bbubgQ/btqIBYZddyl/SmzaHb4kEKBST4x3ZZkjHK/img_640x640.jpg",
      nickname: "길OO",
      age_and_gender: "",
    },
  },
  {
    id: 552,
    tags: ["정책", "상황", "상담", "장례지도사"],
    headline:
      "더 저렴한 업체도 있고 상조회사 하면 누구나 떠올리는 오래된 업체도 있지만, 아빠를 보내드리면서 선택해야 했던 여러가지 중에서 고이의 장례 서비스를 이용한 것이 손에 꼽게 잘한 일",
    good: '상주였던 동생이 아빠의 임종을 기다리던 중 8군데 업체를 비교해보고 가장 친절한 곳이라 계약했다고 해서 처음부터 걱정을 안 했습니다.\n돌아가신 후 장례식장에서 직접 만나보니 역시나 친절하셔서 까탈스러운 동생이 작은 부분까지 게속 질문했음에도 단 한번도 불쾌한 기색 없이 다 받아주셔서 너무 감사했고, 추가금이 필요한 서비스를 강제로 권하지 않으셔서 처음 상담받았던 비용에서 넘어가지 않고 합리적으로 장례를 치를 수 있는 점도 만족스러웠습니다. \n장례의 진행 절차 또한 너무도 매끄러워 번거로운 절차에 대한 고민 없이 아빠를 추억하며 보내드리는 데에 집중할 수 있었고, 슬프고 경황 없는 중에도 남편과 있을 때 이후 또 누군가를 떠나보내는 일이 생긴다면 부모님들께서 미리 준비해두신 상조 서비스 대신 고민 없이 "고이"에 도움을 청하고 싶다는 이야기를 계속 나누었습니다. \n특히 화장터에서 다른 상조업체 소속 장례지도사들과 달리 기다리는 시간 중에도 저희가 언제든 궁금한 점을 여쭤볼 수 있게 시선이 닿는 곳에 계시면서 흐트러지지 않고 차분하고 정돈된 모습을 보여주신 점이 인상깊었습니다. 또 납골당에서 가족들이 충분히 시간을 보낼 수 있도록 기다려주셨는데, 돈을 받고 일하는 직업인이 아닌 고인을 떠나보내는 가족들의 슬픔을 배려하는 전문가로서의 자세가 느껴졌습니다.\n더 저렴한 업체도 있고 상조회사 하면 누구나 떠올리는 오래된 업체도 있지만,  아빠를 보내드리면서 선택해야 했던 여러가지 중에서 고이의 장례 서비스를 이용한 것이 손에 꼽게 잘한 일이라고 생각합니다. 돌아가신 분과 유가족에 대한 배려와 존중이 느껴져 너무 감사했습니다.',
    score: 5,
    created_at: "2024-10-16T04:24:51.670552+09:00",
    district: "-",
    user: {
      picture: "",
      nickname: "고OO",
      age_and_gender: "",
    },
  },
  {
    id: 537,
    tags: ["상황", "상담", "장례지도사"],
    headline:
      "당황스럽고 아무것도 모르는 혼돈스럽고 슬프기만한 상황의3일동안 그야말로 어떤걱정도 되지않는 든든함을 주셔서 너무나 감사드립니다.",
    good: "당황스럽고 아무것도 모르는 혼돈스럽고 슬프기만한 상황의3일동안 그야말로 어떤걱정도 되지않는 든든함을 주셔서 너무나 감사드립니다. 고이를 선택하기전에 이곳저곳비교해보고 고민하다 친절함과 정확함,전문적이고 체계적인부분이 마음에 들어서 선택을 했는데 다른업체를 선택했으면 엄청 후회했을거라는 생각이 들었을거라생각했어요.\n화장터부터 마지막 납골당까지 그이후 처리할일들까지 하나부터 열까지 한치의 불편함과오차없이 모든걸 친절하고 완벽하게 처리해주시고 지도해주신 이대형장례지도사님께 감동의박수와 감사의마음을 전합니다.\n다시는 슬픈일 겪고싶지않치만 또다시 슬픈일이 생긴다면 저와 저희가족들모두 단1초도 고민하지않고 이번장례식동안 만프로를 만족시켜주신 고이장례를 택하겠습니다.\n친절하고 완벽하게 무사히 처리해주신 이대형장례지도사님께 다시한번 고개숙여 깊이 감사인사드립니다.👍👍👍👍👍👍",
    score: 5,
    created_at: "2024-10-04T16:23:43.790612+09:00",
    district: "서울시 양천구",
    user: {
      picture:
        "http://img1.kakaocdn.net/thumb/R640x640.q70/?fname=http://t1.kakaocdn.net/account_images/default_profile.jpeg",
      nickname: "김OO",
      age_and_gender: "46세 여성",
    },
  },
  {
    id: 489,
    tags: ["장례지도사", "상황", "정책"],
    headline:
      "종교식(카톨릭)으로 진행하였음에도 전혀 어려움이 없었으며, 성당 연령회분들과도 원활하게 대신 소통해 주셔서 좋았습니다.",
    good: "김경애 지도사님 덕분에 장모님을 잘 보내드릴수 있었던거 같습니다. 장례를 미리 준비한다고 준비하였지만, 막상 돌아가신 상황이 닥치니 정신도 없고 멍해져서 어떻게 해야될지 몰랐었던거 같습니다. 그런 상황에서 지도사님의 도움이 없었다면 장례를 잘 치루기 어려웠을거 같습니다.\n다시 한번 감사합니다\n\n또한 저희는 종교식(카톨릭)으로 진행하였음에도 전혀 어려움이 없었으며, 성당 연령회분들과도 원활하게 대신 소통해 주셔서 좋았습니다.\n\n처음에는 유명한 상조회사나 회사연계 상조를 이용해야되는거 아니냐는 의견 주신 가족분들도 있었지만 장례를 진행하고 난 이후의 공통적인 의견은 고이상조의 김경애 지도사님이 너무 친절히 진행해주셔서 감사하다는 것이었습니다. \n\n마지막으로 비용적인 부분을 빼놓을수 없는데, 기본적으로 알아본 여타 상조보다 저렴하였기도 했지만, 추가로 대기업 재직중이면 각종 상조서비스(접객도우미, 리무진 등) 지원해주는 경우가 많은데 그런 경우 고이에서 해당 서비스 비용을 제하고 중복되지 않게 합리적으로 이용할 수 있어서 좋았습니다\n\n이러한 이유로 고이를 선택한것에 후회없고,  주변에서 추천을 원할때 고이를 주저없이 말할거 같습니다",
    score: 5,
    created_at: "2024-08-24T01:15:23.876126+09:00",
    district: "서울시 서초구",
    user: {
      picture: "http://k.kakaocdn.net/dn/cF3pkR/btsIn7vr1wJ/ETQEsVEfqo2e93idbefjmK/img_640x640.jpg",
      nickname: "김OO",
      age_and_gender: "",
    },
  },
  {
    id: 486,
    tags: ["상황", "상담", "장례지도사"],
    headline:
      "사전에 알아본 고이를 통해 늦은밤11시 이지만 늦은 시간에 병원에서부터 고인이 안치할수 있는곳까지. 여기저기 연락하시면서 정신없던 저희의 멘토를대신해 백방노력해주셨습니다.",
    good: "안녕하세요. 나름 1달전부터 준비하고하였지만. 막상 그  날이 오니 아무것도 기억이 안났습니다. 그래서 이거 어떻게. 저건 어떻게 발만 둥둥 굴리고 있을때,\n 사전에 알아본 고이를 통해 늦은밤11시 이지만 늦은 시간에 병원에서부터 고인이 안치할수 있는곳까지. 여기저기 연락하시면서\n정신없던 저희의 멘토를대신해 백방노력하시고. 이해시켜주시고.\n처음 고이?상조? 이거모야? 하면서 반신반의했던건 사실입니다.\n하지만 처음부터 끝까지 상주의 입장에서.\n상주의 편의에서. 모시는 유가족의 마음으로 대해 주신건. 단연컨데 고이밖에 없는거 같습니다.\n너무나도 감사한  마음에 바로 글을 남겨봅니다.\n전 사위라 장인어른을 모셨습니다.\n미련이남는지 지금도 혼자 눈물을 흘리고 있지만.\n고이상조덕에 잘모셨고,\n어느하나. 어느한군데\n섭섭치않게. 붎편함 없이.\n요 몆일이 제 인생에 가장 불변함 없이 잘 모셨습니다.\n앞으로 더 도움받고싶고.\n더 감사드리고 싶은 고이 상조입니다.\n\n감사드립니다.\n고맙습니다.\n함께 해준셔서 더할나위없이\n진심으로 감사드립니다",
    score: 5,
    created_at: "2024-08-22T16:34:57.875230+09:00",
    district: "인천시 동구",
    user: {
      picture: "http://k.kakaocdn.net/dn/xCfRu/btsGHvegADH/a6z8yxALkdvLtJHHsPPq2K/img_640x640.jpg",
      nickname: "이OO",
      age_and_gender: "45세 남성",
    },
  },
  {
    id: 485,
    tags: ["상황", "정책", "장례지도사", "상담"],
    headline:
      "문의 즉시 팀장님이 전화를 주셔 꼼꼼히 상담해주셔서 상담 즉시 만원만 내고 상조가입을 했네요",
    good: "아버지께서 급격히 건강이 악화되어 상조회사를 알아보던 중 국가유공자 장례경험이 많다는 고이를 알게 되어 문의를 남겼어요\n문의 즉시 팀장님이 전화를 주셔 꼼꼼히 상담해주셔서 상담 즉시 만원만 내고 상조가입을 했네요\n아버지께서 임종을 하시고 콜 센터에 바로 연락을 넣고 기다렸더니 팀장님께서 전화주셔서 그 후부터 원활히 장례준비가 진행되었어요 \n무엇보다 남은 가족들이 감동 받았던건\n임관식때 아버지 마지막 모습을 소중히\n대하시는 김지훈 팀장님 모습을 보고 참으로 고맙고 감사한마음이 들었어요\n덕분에 아버지의 모습이 참 편안해 보였거든요 \n지금은 아버지를 잘 모시고 나니 한결 마음이 편안하고 나아졌어요\n앞으로도 소중한 사람과의 이별을 앞둔 분들이라면 참고하시면 좋을거 같아요",
    score: 5,
    created_at: "2024-08-21T12:07:46.769017+09:00",
    district: "서울시 동대문구",
    user: {
      picture: "http://k.kakaocdn.net/dn/KAqjH/btssNl4GHuI/d6vDXLNpK6UgFJd40zKqDK/img_640x640.jpg",
      nickname: "노OO",
      age_and_gender: "46세 남성",
    },
  },
  {
    id: 467,
    tags: ["상담", "장례지도사", "정책"],
    headline:
      "병원에서 췌장암 말기의 아버님 임종날짜 임박 소식을 듣고 여러 상조회사 및 장례식장을 알아보다가, 각 장례식장 이용 비용을 정리해놓은 포털사이트를 보던 중 알게되었습니다.",
    good: "병원에서 췌장암 말기의 아버님 임종날짜 임박 소식을 듣고 여러 상조회사 및 장례식장을 알아보다가, 각 장례식장 이용 비용을 정리해놓은 포털사이트를 보던 중 고이장례연구소를 알게 되었습니다.\n\n제가 생각하던 장례 규모를 생각하여 처음에 간단하게 견적 알아보다가 바로 상담까지 진행하게 되어,\n보다 더 빠르게 생각을 정리할 수 있었고 납골당까지 잘 결정할 수 있었습니다. 장례비용 견적을 탄력적으로 잘 알려주셔서 자연스럽게 고이장례를 선택하게 되었습니다.\n\n아버님 별세 후 바로 담당자 분에게 연락드리고 장례식장에서 양태성 장례지도사님의 안내에 따라 차분하게 장례를 진행할 수 있었습니다. \n\n장례가 처음이라 막막한 생각이 들었었지만, \n양태성 장례지도사님께서\n장례식부터 장지까지 모시는 날까지(4일장) 아주 잘 이끌어주셔서, 덕분에 저는 조문객을 한분한분 잘 모실 수 있었습니다. \n\n큰 걱정과 달리 아주 순조롭게 흘러가서 저희 어머님 및 친인척 분들에게도 이번 장례식에 대한 좋은 말씀을 많이 들을 수 있었습니다. 먼저 제가 만족을 많이 했습니다.\n\n양태성 장례지도사님께 다시 한번 감사드리며,\n만약에 앞으로의 이런 일이 생겨도, 또 고이장례를 이용하거나 주변인들에게도 추천을 해주고 싶습니다.\n\n감사합니다.",
    score: 5,
    created_at: "2024-08-06T20:49:39.115298+09:00",
    district: "부산시 수영구",
    user: {
      picture: "http://k.kakaocdn.net/dn/b8A7ld/btsIyz6IQio/t1Y5mld4lCxVQHOThDiKKK/img_640x640.jpg",
      nickname: "송OO",
      age_and_gender: "",
    },
  },
];
